module.exports = __webpack_public_path__ + "static/img/map0.0f3f29f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/map0.png
// module id = //ij
// module chunks = 0